import React, { useState } from 'react'
import toast from 'react-hot-toast';
import { useAuth } from '../../context/UserContext';
import authServices from '../../services/AuthServices';

function UserDeleteModal() {
    const { logout } = useAuth();
    const [confirmText, setConfirmText] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleDelete = async () => {
        if (confirmText.trim() !== 'DELETE') {
            setError('Please type "DELETE" to confirm');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await authServices.deleteUser()
            console.log(response.data);
            toast.success('Account deleted successfully.');
            logout();
        } catch (err) {
            console.error('Delete error:', err);
            setError(err.message || 'Deletion failed. Please try again.');
            toast.error(err.message || 'Could not delete account');
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            <input type="checkbox" id="user-delete-modal" className="modal-toggle" />
            <div className="modal" role="dialog">
                <div className="modal-box w-11/12 max-w-lg">
                    <label
                        htmlFor="user-delete-modal"
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                    >
                        ✕
                    </label>

                    <h3 className="text-lg font-bold mb-4">Delete Profile</h3>
                    <p className="mb-4 text-gray-700 dark:text-gray-300">
                        This action is <strong>permanent and irreversible</strong>.
                        All your data will be erased, including:
                    </p>
                    <ul className="list-disc pl-5 mb-4 text-sm text-gray-600 dark:text-gray-400">
                        <li>Profile information</li>
                        <li>Order history</li>
                        <li>Saved addresses</li>
                        <li>Cart items</li>
                        <li>Vendor data (if applicable)</li>
                    </ul>
                    <p className="mb-4 font-medium">
                        To confirm, please type <code className="bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded">DELETE</code> below:
                    </p>

                    <input
                        type="text"
                        className="input input-bordered w-full mt-1 border p-2 rounded-md border-border-light dark:border-border-dark bg-white dark:bg-slate-800"
                        placeholder="Type DELETE"
                        value={confirmText}
                        onChange={(e) => {
                            setConfirmText(e.target.value.toUpperCase());
                            setError('');
                        }}
                    />

                    {error && (
                        <p className="text-error text-sm mb-3">{error}</p>
                    )}

                    <div className="mt-4">
                        <button
                            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-75"
                            onClick={handleDelete}
                            disabled={loading || confirmText.trim() !== 'DELETE'}
                        >
                            {loading ? 'Deleting...' : 'Delete Account'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserDeleteModal